/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from 'react'
import NavBar from '../components/navigation/navBar'
import Footer from '../components/footer'
import { authHeader } from '../services/utilities'
import { connect } from 'react-redux'
import BrowserNotification from 'components/browserNotification/browserNotification'
import IdleTimeout from 'components/IdleTimeout'

class Layout extends React.Component {
  state = {
    isConsultantView: false,
  }
  componentDidMount() {
    if (!this.props.isConsultant) {
      if (userToken && !userToken.hasOwnProperty('Authorization')) {
        var userToken = authHeader()
        window.location.href = '/login'
      }
    }
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <>
        <IdleTimeout />
        {this.props.browser.outdatedBrowser &&
        this.props.browser.displayNotification ? (
          <BrowserNotification></BrowserNotification>
        ) : null}
        <NavBar></NavBar>

        <main className="main">{this.props.children}</main>

        <Footer></Footer>
      </>
    )
  }
}

function mapStateToProps(state) {
  return {
    isConsultant: state.applicationRoles.isConsultant,
    browser: state.browser,
  }
}

export default connect(mapStateToProps)(Layout)
